import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default new Router({
  mode: 'history',
  routes: [
    //重定向
    {
      path: '/',
      redirect: 'home'
    },
    //首页
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/pages/home/home.vue'], resolve)
    },
    //产品介绍
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['@/pages/product/product.vue'], resolve)
    },
    //新闻中心
    {
      path: '/newsCenter',
      name: 'newsCenter',
      component: resolve => require(['@/pages/newsCenter/newsCenter.vue'], resolve)
    },
    //新闻详情
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: resolve => require(['@/pages/newsCenter/newsDetail.vue'], resolve)
    },
    //超级工资条
    {
      path: '/payslip',
      name: 'payslip',
      component: resolve => require(['@/pages/payslip/payslip.vue'], resolve)
    },
    //关于我们
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: resolve => require(['@/pages/aboutUs/aboutUs.vue'], resolve)
    },

    //手机端首页
    {
      path: '/mobileHome',
      name: 'mobileHome',
      component: resolve => require(['@/pages/home/mobileHome.vue'], resolve)
    },
    //产品介绍
    {
      path: '/mobileProduct',
      name: 'mobileProduct',
      component: resolve => require(['@/pages/product/mobileProduct.vue'], resolve)
    },
    //新闻中心
    {
      path: '/mobileNewsCenter',
      name: 'mobileNewsCenter',
      component: resolve => require(['@/pages/newsCenter/mobileNewsCenter.vue'], resolve)
    },
    //新闻详情
    {
      path: '/mobileNewsDetail',
      name: 'mobileNewsDetail',
      component: resolve => require(['@/pages/newsCenter/mobileNewsDetail.vue'], resolve)
    },
    //超级工资条
    {
      path: '/mobilePayslip',
      name: 'mobilePayslip',
      component: resolve => require(['@/pages/payslip/mobilePayslip.vue'], resolve)
    },
    //关于我们
    {
      path: '/mobileAboutUs',
      name: 'mobileAboutUs',
      component: resolve => require(['@/pages/aboutUs/mobileAboutUs.vue'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js